import { client } from './api-client';

export const mggFetchConfiguration = () => client.get(`v2/mgg/configuration`);
